<ng-container *transloco="let t">
  <authority-labs-base-dialog
    [dialogRef]="dialogRef"
    [title]="title"
    [isDirty]="form.dirty"
  >
    <form content nz-form nzNoColon #form="ngForm" (ngSubmit)="save()">
      <div nz-row [nzGutter]="[16]">
        <div nz-col>
          <nz-form-item *ngIf="!isNew">
            <nz-form-label>{{ t('id') }}</nz-form-label>
            <nz-form-control>
              <input nz-input name="id" readonly [ngModel]="entity.id" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzRequired>{{ t('name') }}</nz-form-label>
            <nz-form-control [nzErrorTip]="t('error.plannerName')">
              <input
                nz-input
                name="name"
                placeholder="{{ t('name') }}"
                required
                [(ngModel)]="entity.name"
              />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzRequired>{{ t('email') }}</nz-form-label>
            <nz-form-control [nzErrorTip]="combineTpl">
              <input
                nz-input
                name="email"
                placeholder="{{ t('email') }}"
                required
                email
                [(ngModel)]="entity.email"
              />
              <ng-template #combineTpl let-control>
                <ng-container *ngIf="control.hasError('email')">{{
                  t('error.email')
                }}</ng-container>
                <ng-container *ngIf="control.hasError('required')">{{
                  t('error.emailRequired')
                }}</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>{{ t('address') }}</nz-form-label>
            <nz-form-control>
              <input
                nz-input
                name="address"
                placeholder="{{ t('address') }}"
                [(ngModel)]="entity.address"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col>
          <nz-form-item>
            <nz-form-label>{{ t('phone') }}</nz-form-label>
            <nz-form-control>
              <input
                nz-input
                name="phone"
                placeholder="{{ t('phone') }}"
                [(ngModel)]="entity.phone"
              />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>{{ t('jobTitle') }}</nz-form-label>
            <nz-form-control>
              <input
                nz-input
                name="jobTitle"
                placeholder="{{ t('jobTitle') }}"
                [(ngModel)]="entity.jobTitle"
              />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>{{ t('companyNumber') }}</nz-form-label>
            <nz-form-control>
              <input
                nz-input
                name="companyNumber"
                placeholder="{{ t('companyNumber') }}"
                [(ngModel)]="entity.companyNumber"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>

    <nz-space actions>
      <ng-template nzSpaceItem>
        <button
          nz-button
          nzType="primary"
          type="submit"
          [nzLoading]="isLoading"
          [disabled]="form.pristine"
          (click)="save()"
        >
          {{ t(submitTitle) }}
        </button>
      </ng-template>
    </nz-space>
  </authority-labs-base-dialog>
</ng-container>
